import { useEffect, useState } from 'react';
import styles from '../formStyles.module.css';
import Button from '@/components/common/Button';
import Api from '@/api';
import AddSubuserInfo from './AddSubuserInfo';
import { useLayoutContext } from '@/context/LayoutContext';
import { useTranslations } from 'next-intl';
import { TRIGGERS } from '@/api/global';
import SignupCode from '../LoginModal/SignupCode';
import isValidMobile from '@/functions/isvalidMobile';
import { setState } from '@/commonTypes';
import SuccessLevel from './SuccessLevel';

type Info = {
  mobile: string;
  nationalCode: string;
  code: string | null;
  error: {
    mobile: boolean;
    code: boolean;
    nationalCode: boolean;
  };
  messages: {
    mobile: string;
    code: string;
    nationalCode: string;
  };
};

type ModalData = Partial<Info> & {
  id?: number | string;
  users?: unknown[];
};

type AddSubuserModalProps = {
  data?: ModalData | null;
  setData?: React.Dispatch<React.SetStateAction<ModalData | undefined>>;
  modalKey: string;
  active?: number;
  setActive?: setState<number>;
};

export default function AddSubuserModal({
  data = null,
  setData,
  modalKey,
  active = 1,
  setActive,
}: AddSubuserModalProps) {
  const { setTrigger, userInfo, setUserInfo, showError } = useLayoutContext();

  const tCommon = useTranslations('common');

  const [loading, setLoading] = useState<boolean>(false);
  const [loadingCode, setLoadingCode] = useState(false);
  const [registeredName, setRegisteredName] = useState('');

  // const [active, setActive] = useState<number>(1);

  const [info, setInfo] = useState<Info>({
    mobile: '',
    nationalCode: '',
    code: '',
    error: {
      mobile: false,
      code: false,
      nationalCode: false,
    },
    messages: {
      mobile: tCommon('requiredField'),
      code: tCommon('requiredField'),
      nationalCode: tCommon('requiredField'),
    },
  });

  useEffect(() => {
    if (data) {
      setInfo((prev) => ({
        ...prev,
        ...data,
      }));
    }
  }, [data]);

  const handleSubmit = (code: string | number | null = null) => {
    const hasError = checkError();

    if (hasError || loading) return;

    let apiCall: Promise<unknown> | null = null;

    if (active === 1) {
      const params = {
        mobile: info.mobile,
        national_code: info.nationalCode,
      };
      setLoading(true);
      apiCall = Api.addSubUserLevel1(params)
        .then((res) => {
          setActive && setActive((prev) => prev + 1);
          setLoading(false);
        })
        .catch((err) => {
          showError(err);
          setLoading(false);
        });
    }

    if (active === 2) {
      const params = {
        mobile: info.mobile,
        national_code: info.nationalCode,
        otp: code ? code : info.code,
      };

      setLoading(true);
      apiCall = Api.addSubUserLevel2(params)
        .then((res) => {
          const registered = res?.data?.response;
          const fullName = [registered?.first_name, registered?.last_name]
            .filter(Boolean)
            .join(' ');
          setRegisteredName(fullName);
          setActive && setActive((prev) => prev + 1);
          setLoading(false);
        })
        .catch((err) => {
          showError(err);
          setLoading(false);
        });
      // setTrigger(TRIGGERS.SUBUSER_MODAL);
    }
    if (active == 0) {
      return;
    }

    // setActive && setActive((prev) => prev + 1);

    /*
    setLoading(true);

    apiCall
      ?.then(() => {
        setData(undefined);
        setTrigger(TRIGGERS.RERENDER);
        setLoading(false);

        if (!data) {
          setUserInfo({
            ...userInfo,
            addresses: Number(userInfo?.addresses) + 1,
          });
        }
      })
      .catch((err: any) => {
        setLoading(false);

        setServerMessage({
          title: 'Sign in error',
          text: err?.message + ', ' + err?.response?.data?.message,
        });
      });
    */
  };

  const checkError = (sendCode = false): boolean => {
    const dummy: Info = structuredClone(info);

    let result = false;
    let values: (keyof Pick<Info, 'mobile' | 'nationalCode' | 'code'>)[] = [];

    if (active === 1) {
      values = ['nationalCode', 'mobile'];
    }

    if (active === 2) {
      values = ['code'];
    }
    if (sendCode) {
      values = ['nationalCode', 'mobile'];
    }

    values.forEach((key) => {
      if (!String(info[key] ?? '').trim()) {
        dummy.error[key] = true;
        result = true;
      }
      if (key == 'mobile') {
        console.log('mobile==============', isValidMobile(info?.['mobile']));
        if (!isValidMobile(info?.['mobile']) && String(info?.[key])?.trim()?.length != 0) {
          dummy.error[key] = true;
          dummy.messages[key] = 'شماره موبایل معتبر نیست';
          result = true;
        }
      }
    });

    setInfo(dummy);

    return result;
  };
  const onKeyDown = (e: any) => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };
  const onComplete = (code?: string | number | null) => {
    handleSubmit(code);
  };
  const onChange = (value: string | number, key: string) => {
    let valueIs = {
      ...info,
      [key]: value,
      error: {
        ...info?.error,
        [key]: false,
      },
    };

    setInfo(valueIs);
  };
  const handleResendCode = () => {
    const params = {
      mobile: info.mobile,
      national_code: info.nationalCode,
    };
    setInfo({ ...info, code: '' });
    const hasError = checkError(true);

    if (hasError) {
      return Promise.reject(new Error('Validation failed'));
    }

    setLoadingCode(true);

    return Api.addSubUserLevel1(params)
      .then((res) => {
        setLoadingCode(false);
        return res;
      })
      .catch((err) => {
        setLoadingCode(false);

        showError(err);

        throw err; // <-- IMPORTANT
      });
  };

  return (
    <div className={`${styles.container} ${styles.addressFormContainer}`}>
      {active == 1 && (
        <AddSubuserInfo info={info} setInfo={setInfo} modalKey={modalKey} onKeyDown={onKeyDown} />
      )}
      {active == 2 && (
        <div
          className={`${styles.formContainer} ${styles.formContainerGrid1} ${styles.formAutoHeight} mt-0`}
        >
          <SignupCode
            length={6}
            onKeyDown={onKeyDown}
            onChange={onChange}
            sendCodeFunction={handleResendCode}
            info={info}
            setInfo={setInfo}
            loading={loading}
            onComplete={onComplete}
          />
        </div>
      )}
      {active == 3 && (
        <SuccessLevel
          title={
            registeredName ? `کاربر ${registeredName} به گاراژ اضافه شد` : 'کاربر به گاراژ اضافه شد'
          }
        />
      )}

      {active != 3 ? (
        <Button
          onClick={() => handleSubmit(null)}
          className={`btn btn-primary w-full squareButton ${styles.subUserButton} noBoxShadow`}
          wrapperStyle={`w-full`}
          loading={loading}
          showAnimation={false}
        >
          {active == 1 ? tCommon('submitandContiniue') : 'ثبت کاربر جدید'}
        </Button>
      ) : (
        <Button
          className={`btn btn-blue  w-full squareButton ${styles.fullButtonLink}`}
          wrapperStyle={`w-full`}
          type="link"
          href={`/sub-users?garage=true`}
        >
          بازگشت به گاراژ
        </Button>
      )}
    </div>
  );
}
